var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 1.75v28.5A.75.75 0 0 1 23 31H9a.75.75 0 0 1-.75-.75V1.75A.75.75 0 0 1 9 1h14a.75.75 0 0 1 .75.75zM6.808 4.769v4.308a.75.75 0 0 1-.75.75H1.75a.75.75 0 0 1-.75-.75V4.769a.75.75 0 0 1 .75-.75h4.308a.75.75 0 0 1 .75.75zM6.808 23.077v4.308a.75.75 0 0 1-.75.75H1.75a.75.75 0 0 1-.75-.75v-4.308a.75.75 0 0 1 .75-.75h4.308a.75.75 0 0 1 .75.75zM6.808 13.923v4.308a.75.75 0 0 1-.75.75H1.75a.75.75 0 0 1-.75-.75v-4.308a.75.75 0 0 1 .75-.75h4.308a.75.75 0 0 1 .75.75zM31 4.769v4.308a.75.75 0 0 1-.75.75h-4.308a.75.75 0 0 1-.75-.75V4.769a.75.75 0 0 1 .75-.75h4.308a.75.75 0 0 1 .75.75zM31 23.077v4.308a.75.75 0 0 1-.75.75h-4.308a.75.75 0 0 1-.75-.75v-4.308a.75.75 0 0 1 .75-.75h4.308a.75.75 0 0 1 .75.75zM31 13.923v4.308a.75.75 0 0 1-.75.75h-4.308a.75.75 0 0 1-.75-.75v-4.308a.75.75 0 0 1 .75-.75h4.308a.75.75 0 0 1 .75.75z",
    fill: "#ff02c7",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTables);
export default __webpack_public_path__ + "static/media/Tables.ef92117310b4ba338aadc7d52d2c6ace.svg";
export { ForwardRef as ReactComponent };